import type { ReactNode } from "react";
import { cx } from "shared/utils";
import { Show } from "shared/components/helpers/Show";
import type { BannerButtonGroupProps } from "./BannerButtonGroup";
import { BannerButtonGroup } from "./BannerButtonGroup";

export type BannerBodySectionProps = {
  title?: string;
  body?: string | ReactNode;
  titleColor: string;
  bodyColor: string;
  bodyClassName?: string;
  hasButtons: boolean;
  buttonGroupProps: BannerButtonGroupProps;
};

export const BannerBodySection = ({
  title,
  body,
  titleColor,
  bodyColor,
  bodyClassName,
  hasButtons,
  buttonGroupProps
}: BannerBodySectionProps) => {
  const isButtonsRight =
    (buttonGroupProps.buttonGroupPosition ?? "right") === "right";
  return (
    <div className="min-w-0 flex-1 space-y-1">
      <Show if={!!title}>
        <p className={cx("text-base font-bold leading-6", titleColor)}>
          {title}
        </p>
      </Show>
      <Show if={!!body}>
        <div
          className={cx(
            "text-sm font-medium leading-5",
            bodyColor,
            typeof body === "string" ? "" : "space-y-1",
            bodyClassName
          )}
        >
          {body}
        </div>
      </Show>
      <Show if={!!hasButtons && !isButtonsRight}>
        <BannerButtonGroup {...buttonGroupProps} />
      </Show>
    </div>
  );
};
